import { AppNavDesktop } from "./AppNavDesktop.js";
import { AppNavMobile } from "./AppNavMobile.js";
import "react";
import { useIsBreakpointActive } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
// src/modules/AppWrapper2/components/AppNav/index.tsx
function AppNav() {
	if (!useIsBreakpointActive("sm")) return /* @__PURE__ */ jsx(AppNavMobile, {});
	return /* @__PURE__ */ jsx(AppNavDesktop, {});
}
export { AppNav };

//# sourceMappingURL=index.js.map